import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHomepage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          {isHomepage ? (
            <h1>
              <Link
                to="/"
                className={`font-heading text-xl font-semibold tracking-tight whitespace-nowrap ${
                  scrolled ? 'text-foreground-900' : 'text-white'
                }`}
              >
                CSSSpreadsheet
              </Link>
            </h1>
          ) : (
            <Link
              to="/"
              className={`font-heading text-xl font-semibold tracking-tight whitespace-nowrap ${
                scrolled ? 'text-foreground-900' : 'text-white'
              }`}
            >
              CSSSpreadsheet
            </Link>
          )}

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#categories"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Categories
            </a>
            <a
              href="#articles"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
              }`}
            >
              Guides
            </a>
            <a
              href="#about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
              }`}
            >
              About
            </a>
            <a
              href="#faq"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled ? 'text-foreground-700 hover:text-foreground-900' : 'text-white/80 hover:text-white'
              }`}
            >
              FAQ
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className={`inline-flex items-center px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              CSSBuy Sheet
              <i className="ri-arrow-right-up-line ml-1.5"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-6 py-4 flex flex-col gap-3">
          <a href="#categories" className="text-foreground-700 text-sm font-medium py-2" onClick={() => setMobileOpen(false)}>Categories</a>
          <a href="#articles" className="text-foreground-700 text-sm font-medium py-2" onClick={() => setMobileOpen(false)}>Guides</a>
          <a href="#about" className="text-foreground-700 text-sm font-medium py-2" onClick={() => setMobileOpen(false)}>About</a>
          <a href="#faq" className="text-foreground-700 text-sm font-medium py-2" onClick={() => setMobileOpen(false)}>FAQ</a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-up-line ml-1.5"></i>
          </a>
        </div>
      )}
    </nav>
  );
}